import { z } from 'zod';

export const spacesQueryFiltersSchema = z.object({
  viewId: z.string().nullish(),
  spaceIds: z.array(z.string()).nullish(),
  spaceName: z.string().nullish(),
  spaceType: z.enum(['all', 'active', 'archived']).default('active'),
  ownerIds: z.array(z.string()).optional(),
  mapStatus: z
    .array(
      z.enum([
        'notCreated',
        'notStarted',
        'stalled',
        'inProgress',
        'overdue',
        'completed',
      ]),
    )
    .nullish(),
  templateIds: z.array(z.string()).nullish(),
  teamIds: z.array(z.string()).nullish(),
  collaboratorAccess: z.boolean().nullish(),
  myTeamAccess: z.boolean().nullish(),
  companyTeamAccess: z.boolean().nullish(),
  createdAfter: z.date().nullish(),
  sortBy: z
    .enum([
      'companyName',
      'mapProgress',
      'createdAt',
      'updatedAt',
      'ownerId',
      'lastVisit',
      'activitiesCount',
      'score',
      'visits',
    ])
    .nullish(),
  sortDirection: z.enum(['asc', 'desc']).nullish(),
  page: z.number().nullish(),
  pageSize: z.number().nullish(),
});

export type SpacesQueryFilters = z.infer<typeof spacesQueryFiltersSchema>;
